import { colors } from '../const';
import { askQuestion } from './prompts';
import { hasCommand, runCommandSync } from './exec';

export type VercelCliContext = {
  vercelCmd: string;
  useNpx: boolean;
}

export async function checkVercelCli(): Promise<VercelCliContext> {
  console.log(`\n${colors.dim}Step 2/4: Checking Vercel CLI...${colors.reset}`);
  let vercelCmd = 'vercel';
  let useNpx = false;

  if (!hasCommand('vercel')) {
    console.log(`❓ ${colors.yellow}Vercel CLI was not found on your system.${colors.reset}`);
    const answer = await askQuestion(`👉 Would you like to install Vercel CLI globally? (Y/n): `);

    if (answer.toLowerCase() === 'y' || answer === '') {
      console.log(`\n📥 ${colors.cyan}Installing Vercel CLI globally... (npm install -g vercel)${colors.reset}`);
      const success = runCommandSync('npm', ['install', '-g', 'vercel']);
      if (success && hasCommand('vercel')) {
        console.log(`✔ ${colors.green}Vercel CLI installed successfully!${colors.reset}`);
      }
      else {
        console.log(`\n⚠️  ${colors.yellow}Global installation failed or permissions restricted.${colors.reset}`);
        console.log(`ℹ ${colors.dim}Falling back: Running Vercel dynamically via npx.${colors.reset}`);
        vercelCmd = 'npx --yes vercel';
        useNpx = true;
      }
    }
    else {
      console.log(`ℹ ${colors.dim}Skipping global installation. Running Vercel dynamically via npx.${colors.reset}`);
      vercelCmd = 'npx --yes vercel';
      useNpx = true;
    }
  } else {
    console.log(`✔ ${colors.green}Vercel CLI is installed!${colors.reset}`);
  }

  return { vercelCmd, useNpx };
}
